import Component,{register} from '@services/component';
import {toggleClass} from '@services/dom';
import youtube from '@services/youtube';
import {subscribe} from '@services/events';
// import {disabled as disableWheel} from '@services/wheel';
import {isMobile} from '@services/browser';

export default register(
    class FigureVideoLink extends Component{
        static selector = '.figure-link[href*="youtube.com"]'

        async create(){
          if(isMobile){
            this.createMobilePreview();
          }else{
            this.createDesktopPlayer();
          }
        }

        async createMobilePreview() {
          const fullscreenButton = document.createElement('span');
          fullscreenButton.className = 'video-button';
          fullscreenButton.innerHTML = '<span class="sr-only">abspielen</span>';
          this.el.addEventListener('click',e=>{
            e.preventDefault();
            this.toggleFullscreen(true);
          });
          this.el.appendChild(fullscreenButton);
        }

        get videoId(){
          const {href=""} = this.el;
          const [,videoId=""] = href.match(/\?v=([^\&^\/]+)/) || [];
          return videoId;
        }

        async createDesktopPlayer() {
          const {videoId} = this;

          const hasCustomThumbnail = true;

          const player = await youtube(
            {
              className: 'youtube lightbox',
              videoId,
              width:window.innerWidth,
              height:window.innerWidth / 16 * 9,
              playerVars:{
                controls:0,
                showinfo:0,
                showsearch:0,
                rel:0,
                fs:0,
                autohide:1,
                disablekb:1,
                iv_load_policy:3,
                loop:1,
                playlist:videoId,
                modestbranding:1,
                origin:location.protocol + '//' + location.host,
                enablejsapi:1,
              },
              events:{
                onReady(event){
                  event.target.mute();
                  if(!isMobile){
                    if(hasCustomThumbnail){
                      event.target.seekTo(0);
                      event.target.pauseVideo();
                    }else{
                      event.target.playVideo();
                    }
                  }
                },
                onStateChange: event => {
                  if(event.data === window.YT.PlayerState.ENDED && this._isFullscreen){
                    this.toggleFullscreen(false);
                  }
                }
              }
            }
          );
          const fullscreenButton = document.createElement('span');
          fullscreenButton.className = 'video-button';
          fullscreenButton.innerHTML = '<span class="sr-only">abspielen</span>';
          this.el.addEventListener('click',e=>{
            e.preventDefault();
            this.toggleFullscreen(true);
          });

          const playButton = document.createElement('button');
          playButton.className = 'video-button';
          playButton.innerHTML = '<span class="sr-only">abspielen</span>';
          playButton.addEventListener('click',this.togglePlayPause.bind(this));

          const closeButton = document.createElement('button');
          closeButton.className = 'video-close-button';
          closeButton.innerHTML = '<span class="sr-only">schließen</span>';
          closeButton.addEventListener('click',this.toggleFullscreen.bind(this,false));

          if(!this.el){
            player.destroy();
          }else{
            this.player = player;
            toggleClass(this.player.element,'has-thumbnail', hasCustomThumbnail);
            document.querySelector('#page-content').appendChild(player.element);
            // this.el.insertBefore(player.element,this.el.firstChild);
            this.el.appendChild(fullscreenButton);
            player.element.appendChild(closeButton);
            player.element.appendChild(playButton);
            this.on(player.element,'click',this.togglePlayPause.bind(this));
          }
        }

        destroy(){
          this.player && this.player.destroy();
          this.unsubOffset && this.unsubOffset();
          super.destroy();
        }

        toggleFullscreen(force){
          if(isMobile && force){
            const {videoId} = this;
            window.open(`https://youtube.com/watch?v=${videoId}`);
            return;
          }

          const {controller,element} = this.player;

          if(force===undefined){
            force = !this._isFullscreen;
          }else if(force === this._isFullscreen){
            return;
          }
          this._isFullscreen = force;
          toggleClass(element,'is-fullscreen',force);
          if(force){
            controller.unMute();
            controller.seekTo(0);
            controller.playVideo();
            toggleClass(element,'is-paused',false);
            this.closeOnNextScroll();
            // disableWheel(true);
          }else{
            controller.mute();
            // disableWheel(false);
          }
        }

        togglePlayPause(){
          if(!this._isFullscreen) return;
          const {controller,element} = this.player;
          if(controller.getPlayerState() === 1){
            controller.pauseVideo();
            toggleClass(element,'is-paused',true);
          }else{
            controller.playVideo();
            toggleClass(element,'is-paused',false);
          }
        }

        closeOnNextScroll(){
          this.unsubOffset = subscribe(this.el,'sections:offsetchange',(e)=>{
            if(Math.abs(e.detail.offset) > .4){
              this.unsubOffset();
              this.unsubOffset = null;

              this.toggleFullscreen(false);
            }
          })
        }
    }
)